import React from 'react';

import { ButtonV2, Link } from '@zola/zola-ui';

import { trackEditRegistryClick } from '../util/tracking';

const BuildZolaRegistryCTA = ({
  ctaText = 'Build Your Zola Registry',
  hasExternalRegistry,
  component = 'Button', // ['Button', 'Link']
  trackingPayload, // {recommendation_key: ..., recommendation_name:..., section:... }
  ...props
}) => {
  // const trackWebsiteZolaRegistry = () => {
  //   const recommendationKey = hasExternalRegistry
  //     ? 'website_registry_signup_yes_outside'
  //     : 'website_registry_signup_no_outside';
  //   const recommendationName = hasExternalRegistry
  //     ? 'Website Registry Signup Yes Outside'
  //     : 'Website Registry Signup No Outside';

  //   trackRecommendation('Clicked', {
  //     recommendation_key: recommendationKey,
  //     recommendation_name: recommendationName,
  //     recommendation_copy: ctaText,
  //   });
  // };

  const handleClick = () => {
    if (trackingPayload) {
      trackEditRegistryClick(trackingPayload);
    }
  };

  if (component === 'Link') {
    return (
      <Link arrow {...props} href="/onboard/new" onClick={handleClick}>
        {ctaText}
      </Link>
    );
  }
  return (
    <ButtonV2 component="a" role="link" href="/onboard/new" onClick={handleClick} {...props}>
      {ctaText}
    </ButtonV2>
  );
};

export default BuildZolaRegistryCTA;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/components/BuildZolaRegistryCTA.jsx